import React from "react";
import { useNavigate } from "react-router-dom";
import "./styles/dashboard.css";
import CommonHeader from "./components/CommonHeader";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <>
      <div class="d-flex flex-column flex-lg-row h-lg-full bg-surface-secondary">
        <div class="h-screen flex-grow-1 overflow-y-lg-auto">
          <CommonHeader />
          <main class="py-6 bg-surface-secondary">
            <div class="container-fluid">
              <div class="row justify-content-center">
                <div class="col-lg-6 col-md-8 col-sm-12">
                  <div class="card shadow border-0 text-center">
                    <div class="card-body py-5">
                      <div class="mb-4">
                        <i class="bi bi-exclamation-triangle text-warning" style={{ fontSize: "4rem" }}></i>
                      </div>
                      <h1 class="display-1 text-muted mb-3">404</h1>
                      <h2 class="h4 mb-3">Page Not Found</h2>
                      <p class="text-muted mb-4">
                        The page you're looking for doesn't exist or has been moved.
                      </p>
                      <div class="d-flex flex-column flex-sm-row gap-2 justify-content-center">
                        <button
                          class="btn btn-primary"
                          onClick={() => navigate('/bookings')}
                        >
                          <i class="bi bi-house me-2"></i>
                          Go to Bookings
                        </button>
                        <button
                          class="btn btn-outline-secondary"
                          onClick={() => navigate('/users')}
                        >
                          <i class="bi bi-people me-2"></i>
                          Go to Users
                        </button>
                        <button
                          class="btn btn-outline-secondary"
                          onClick={() => window.history.back()}
                        >
                          <i class="bi bi-arrow-left me-2"></i>
                          Go Back
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default NotFound; 